import { Navigate, Outlet } from 'react-router-dom'
import Navbar from 'components/navbar/Navbar'
import 'react-toastify/dist/ReactToastify.css'
// import {ToastContainer} from 'react-toastify'
import { useEffect, useState } from 'react'
import { useRequest } from 'hooks/useRequest'
import { getRoles } from 'redux/features/general/generalSlice'
import { useDispatch } from 'react-redux'
import Sidebar from 'components/sidebar/Sidebar'
const Layout = () => {
	const [authData, setAuthData] = useState(JSON.parse(localStorage.getItem('auth')))
	const [getAllRoles] = useRequest()
	const dispatch = useDispatch()


	useEffect(() => {
		setAuthData(JSON.parse(localStorage.getItem('auth')))
		if (authData?.token) {
			getAllRoles('/Role/GetAllRoles', { method: 'GET' }).then(res => {
				dispatch(getRoles(res.data.result))
			})
		}
	}, [])

	if (!authData?.token) {
		return <Navigate to='/login' />
	}
	return (
		<div className='layout'>
			<Sidebar />
			<div className='layout-main-container'>
				<Navbar />
				<Outlet />
			</div>
		</div>
	)
}

export default Layout
